import { render } from "./SectionAesthetic.vue?vue&type=template&id=49980a69&scoped=true"
const script = {}

import "./SectionAesthetic.vue?vue&type=style&index=0&id=49980a69&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49980a69"]])

export default __exports__